import React, { useCallback, useState } from 'react';
import { useDataExtractionPagination, useDataExtractionFetching, useDataExtractionCheckSelection } from './index';
import { FormFields } from '@/types/entities/DataExtraction';

interface UseDataExtractionTableProps {
	filters: FormFields;
}

export function useDataExtractionTable({ filters }: UseDataExtractionTableProps) {
	const [clearSelectionFlag, setClearSelectionFlag] = useState<boolean>(false);
	const { pagination, changePage, changeLimit } = useDataExtractionPagination();

	const { tableData } = useDataExtractionFetching(filters, pagination);

	const triggerClearSelection = useCallback(() => {
		setClearSelectionFlag((prev: boolean) => !prev);
	}, []);

	const {
		totalSelectedCount,
		selectedIds,
		selectedRowKeys,
		isAllSelected,
		isIndeterminate,
		handleMainCheckboxChange,
		handleRowCheckboxChange,
		clearSelection
	} = useDataExtractionCheckSelection(tableData, triggerClearSelection);

	React.useEffect(() => {
		if (clearSelectionFlag) {
			clearSelection();
		}
	}, [clearSelectionFlag, clearSelection]);

	return {
		tableData,
		pagination,
		changePage,
		changeLimit,
		selectedIds,
		selectedRowKeys,
		isAllSelected,
		isIndeterminate,
		handleMainCheckboxChange,
		handleRowCheckboxChange,
		totalSelectedCount,
		triggerClearSelection
	};
}
